import type { MemberAccessRule } from './types.js';

export const JAVA_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'field_access', objectField: 'object', propertyField: 'field', tagKind: 'member' },
  { parentType: 'method_invocation', objectField: 'object', propertyField: 'name', tagKind: 'call' },
];
